import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import { Registration } from '../../legacy'
import { closeModal } from 'aria-viewer/modal/modalActions'
import { CTA_BUTTON_CLICKED, TOUR_STARTED } from 'aria-viewer/modal/constants/ModalSources'
import { LoadingIndicator } from 'aria-viewer/loadingscreen'
import colors from 'aria-viewer/tour/constants/style/colors'
import { registrationLoaded, onRegistrationPolicyLinkClicked } from 'aria-viewer/registration/registrationActions'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import Analytics from 'aria-viewer/analytics/utils/analytics'
import $ from 'jquery'
import compose from 'recompose/compose'

const S = {
    taglineContainer: {
        width: '100%',
        textAlign: 'center',
        color: '#B6B0AD',
        fontWeight: 500,
        fontSize: 18,
    },
    innerContainer: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minHeight: '80%',
    },
    registrationContainer: {
        position: 'relative',
        flex: 'auto',
    },
    mobileLoadingIndicator: {
        flex: 1,
        zIndex: 1000000,
        background: colors.white,
        height: 'calc(100vh - 45px)',
    },
    desktopLoadingIndicator: {
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 100,
        height: 100,
    },
}

class RegistrationPage2 extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
        }
    }

    handleClose = () => {
        const { onClose } = this.props
        return onClose && onClose()
    }

    init = props => {
        const {
            location: { loc_id },
            userkey,
            sessionId,
            platform,
            originalPlatform,
            bindRegistration,
            registrationForm,
            handleFieldChange,
            handleFieldError,
            onRegistrationSuccess,
            onRegistrationSubmitted,
            handleResumePageScroll,
            mobile = true,
            tablet = false,
            formClass = Registration.prototype.themes.material_ui,
            activeRegistrationModalSource,
            handleFocusField,
            registrationLoaded,
            experienceName,
            onRegistrationPolicyLinkClicked,
        } = props

        if (registrationForm) {
            this.registration = registrationForm
        } else if (loc_id && loc_id !== this.loc_id && userkey && platform && this.refs.registration) {
            this.loc_id = loc_id
            this.registration = new Registration({
                loc_id,
                userkey,
                sessionId,
                mobile,
                tablet,
                formClass,
                loc_name: experienceName,
                //we should resolve this naming convention conversion
                original_source: originalPlatform,
                testing: false,
                source: platform,
                hideLoading: true,
                onClose: this.handleClose,
                onComplete: onRegistrationSuccess,
                onSubmit: onRegistrationSubmitted,
                onFieldChange: handleFieldChange,
                onFieldError: handleFieldError,
                onFieldFocus: handleFocusField,
                onPolicyLinkClicked: onRegistrationPolicyLinkClicked,
                onResumePageScroll: handleResumePageScroll,
                userOnCampus: Analytics.isGpsInBounds(),
                isRegInitByCTA: activeRegistrationModalSource === CTA_BUTTON_CLICKED,
            })
            bindRegistration(this.registration)
        }

        //Reappend the form
        if (this.registration) {
            $(this.refs.registration).append(this.registration.registrationWrapAll)
            if (this.props.policyContainerRef) {
                $(this.props.policyContainerRef).append(this.registration.policyContainer)
            }
        }

        //Reveal the form
        if (this.registration && (!Registration.isOpen || activeRegistrationModalSource == TOUR_STARTED)) {
            this.registration.open({
                allowCache: true,
                isRegInitByCTA: activeRegistrationModalSource == CTA_BUTTON_CLICKED,
                formVisibleCb: registrationLoaded,
                errorCb: registrationLoaded,
                loadedCb: this.formLoaded,
            })
        } else {
            this.setState({ visible: true })
            registrationLoaded()
        }
    }
    componentDidMount() {
        const { onLoad } = this.props

        onLoad && onLoad()

        this.init(this.props)
    }
    componentWillReceiveProps(props) {
        this.init(props)
    }
    componentWillUnmount() {
        if (this.registration) {
            this.registration.clearErrors()
        }
    }

    formLoaded = () => {
        const { fields = [], fieldsUpdated } = this.props
        Object.keys(fields).forEach(key => {
            const { id, value } = fields[key]
            id && this.registration.hasField(id) && this.registration.getField(id).setValue(value)
            // this line was causing the email field to get a focus style on mobile, but not actually focus the field.
            // commenting it out for that reason and also it seems illogical to loop, focusing each field on load
            //id && this.registration.focusField(id);
        })
        this.setState({ visible: true })
        fieldsUpdated && fieldsUpdated()
    }
    showLoadingIndicator() {
        return (
            !this.state.visible && (
                <LoadingIndicator
                    outerSizes={this.props.mobile ? { outerWidth: 24, outerHeight: 14 } : {}}
                    class={this.props.mobile ? 'yellow' : 'gray'}
                    style={this.props.mobile ? S.mobileLoadingIndicator : S.desktopLoadingIndicator}
                />
            )
        )
    }
    render() {
        const { style, tagline } = this.props
        return (
            <div style={style}>
                <div style={S.innerContainer}>
                    <div style={S.taglineContainer}>{tagline}</div>
                    <div style={S.registrationContainer}>
                        <div className="registration-page-2" ref="registration" style={{ fontSize: 16 }} />
                    </div>
                </div>
                {this.showLoadingIndicator()}
            </div>
        )
    }
}
export default compose(
    connect(
        mapSelectorsToProps(['location', 'userkey', 'platform', 'originalPlatform', 'activeRegistrationModalSource']),
        {
            closeModal,
            registrationLoaded,
            onRegistrationPolicyLinkClicked,
        }
    ),
    connect(state => ({
        sessionId: state.getIn(['analytics', 'sessionId']),
    }))
)(RegistrationPage2)
